module.exports = __webpack_public_path__ + "img/kolaudacia.0877a946.svg";